module.exports = __webpack_public_path__ + "img/Distant_Memory.8fafeea1.png";